import { forwardRef, type Ref, type SVGProps } from "react";

function SvgMobilePhone(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={177}
      height={120}
      fill="none"
      {...props}
    >
      <path
        stroke="#3B4C65"
        d="M73.063 40.476v.818l.727-.373a6 6 0 0 1 2.741-.66h24.938c3.33 0 6.031 2.707 6.031 6.048v27.382c0 5.97-4.828 10.809-10.781 10.809H81.28c-5.953 0-10.781-4.838-10.781-10.81V36.787c0-.712.575-1.286 1.281-1.286.707 0 1.281.575 1.281 1.286zm8.218 8.31A2.283 2.283 0 0 0 79 51.07v13.096a2.284 2.284 0 0 0 2.281 2.285H96.72A2.284 2.284 0 0 0 99 64.167V51.07a2.283 2.283 0 0 0-2.281-2.285z"
      />
      <circle cx={89} cy={60} r={50} stroke="url(#MobilePhone_svg__a)" strokeWidth={10} />
      <defs>
        <linearGradient
          id="MobilePhone_svg__a"
          x1={89}
          x2={89}
          y1={10}
          y2={110}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgMobilePhone);
export default ForwardRef;
